export default {
  common: {
    share: 'Teilen',
    read_more: 'Mehr',
    more: 'Mehr',
    less: 'Weniger',
    blog: 'Blog',
  },
  blog: {
    min_read: '{min} min gelesen',
    related_articles: 'Verwandte Artikel',
    blog_name: `DER SEU-<span class="blog-text-highlight">{blog}</span>`,
    search: 'suche',
    all_categories:'Alle',
    no_posts:'Keine Einträge gefunden'
  },
  footer: {

    links: 'links',
    social_media: 'Soziale Medien',
    sitemap: 'Sitemap',
    seu: 'SEU',
    challenges: 'Herausforderungen',
    strategy: 'Strategie',
    services: 'Angebot',
    engineering: 'Engineering',
    about: 'Wir',
    blog: 'Blog',
    contact: 'Kontakt',
    arrival: 'Anfahrt',
    media: 'Medien',
    newsletter: 'Newsletter',
    jobs: 'Jobs',
    imprint:'Impressum',
    terms:'Datenschutz',
    copyright:'Copyright © 2023 Swiss Engineers United. All rights reserved.',
  },
  newsletter: {
    enter_email:'E-Mail-Adresse eingeben',
    subscribe_btn:'Jetzt anmelden',
    email_required:'Eine gültige E-Mail-Adresse ist erforderlich'

  }
}
